import React, { useState } from 'react';
import Draggable from 'react-draggable';

const Screen1 = ({ title, onClose, children, position, zIndex, onFocus, focused }) => {
  const [closing, setClosing] = useState(false);

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (closing) return;
    setClosing(true);
    // let the collapse animation play before unmount
    setTimeout(onClose, 260);
  };

  return (
    <Draggable handle=".window-header" bounds="parent" defaultPosition={position}>
      <div
        className={`window ${closing ? 'window-closing' : 'window-opening'}${focused ? ' window-focused' : ''}`}
        style={zIndex ? { zIndex } : undefined}
        onMouseDown={onFocus}
        onTouchStart={onFocus}
      >
        {/* inner pane — outer div acts as the chamfered neon frame */}
        <div className="window-inner">
          <div className="window-header">
            <span className="win-header-accent" aria-hidden="true" />
            <span className="win-title glitch-text" data-text={title}>{title}</span>
            <span className="win-header-id">SYS//{String((title || '').length * 137 % 9999).padStart(4, '0')}</span>
            <button className="win-close" onClick={handleClose} onTouchEnd={handleClose}>✕</button>
          </div>
          <div className="window-content">
            {children}
          </div>
        </div>
      </div>
    </Draggable>
  );
};

export default Screen1;
